/**
 * Centralized route configuration
 * For System Tower (Platform Admin)
 */

export const ROUTES = {
  // Public routes
  LOGIN: '/login',
  REGISTER: '/register',

  // Private routes (under /dashboard)
  DASHBOARD: '/dashboard',
  DASHBOARD_HOME: '/dashboard/home',
  PORTALS: '/dashboard/portals',
  CREATE_PORTAL: '/dashboard/portals/create',
  CREATE_PORTAL_SCRATCH: '/dashboard/portals/create/scratch',
  CREATE_PORTAL_COPY: '/dashboard/portals/create/copy',
  PORTAL_DETAIL: '/dashboard/portals/:portalId',
  PORTAL_SSO_ADD: '/dashboard/portals/:portalId/sso/add',
  PORTAL_SSO_EDIT: '/dashboard/portals/:portalId/sso/:providerId/edit',
  USERS: '/dashboard/users',
  SYSTEM_SETTINGS: '/dashboard/settings',
  AUTH_CALLBACK: '/auth/callback',
  CHANGE_PASSWORD: '/change-password',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',

  // Fallback
  ROOT: '/',
} as const;

// Route labels for navigation
export const ROUTE_LABELS = {
  [ROUTES.DASHBOARD_HOME]: 'Dashboard',
  [ROUTES.PORTALS]: 'Portals',
  [ROUTES.USERS]: 'Users',
  [ROUTES.SYSTEM_SETTINGS]: 'Settings',
} as const;
